import { styled } from 'goober';

export const Body = styled('form')`
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const Footer = styled('div')`
    display: flex;
    width: 100%;
    gap: 12px;
    justify-content: flex-end;
`;

export const InputGroup = styled('div')`
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    gap: 24px;
`;

export const InputGrid = styled('div')`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
`;

export const SelectGrid = styled('div')`
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
`;

export const InputContactsGrid = styled(InputGrid)`
    & > *:first-child {
        grid-column: 1 / -1;
    }
`;

export const ManagerWrapper = styled('div')`
    position: relative;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    gap: 24px;
`;
